import { Reducer } from "react";
import { AuctionActionCalendarEnum, IAuctionCalendarState, AuctionCalendarActions } from ".";
import { IFilterItem } from "..";
import { product } from "../../features/AuctionCalendar";
import { ExchangeTypeEnum } from "../../services";

const initialProductState: IFilterItem[] = [
  { value: product.weekly, isSelected: true },
  { value: product.weekend, isSelected: true },
  { value: product.monthly, isSelected: true },
  { value: product.seasonal, isSelected: true },
  { value: product.quarterly, isSelected: true },
  { value: product.yearly, isSelected: true },
];

const initialExchangeState = [
  { value: ExchangeTypeEnum.Jao.toUpperCase(), isSelected: true },
  { value: ExchangeTypeEnum.Empire.toUpperCase(), isSelected: true },
];

export const initialState: IAuctionCalendarState = {
  loading: true,
  initialFilters: {
    products: initialProductState,
    isShow: true,
    exchanges: initialExchangeState,
  },
  currentFilters: {
    products: initialProductState,
    isShow: true,
    exchanges: initialExchangeState,
  },
};

export const auctionCalendarReducer: Reducer<IAuctionCalendarState, AuctionCalendarActions> = (
  state = initialState,
  action: AuctionCalendarActions
) => {
  switch (action.type) {
    case AuctionActionCalendarEnum.FetchFiltersAndAuctionCalendar:
      return {
        ...state,
        loading: action?.state?.loading,
        initialFilters: {
          ...state.initialFilters,
          exchanges: action?.state?.initialFilters?.exchanges,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
        },
        currentFilters: {
          ...state.currentFilters,
          exchanges: action?.state?.initialFilters?.exchanges,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
        },
      };
    case AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarSuccess:
      return {
        ...state,
        data: action.state?.data,
        loading: false,
        initialFilters: {
          ...state.initialFilters,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
          exchanges: action?.state?.initialFilters?.exchanges,
        },
        currentFilters: {
          ...state.currentFilters,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
          exchanges: action?.state?.initialFilters?.exchanges,
        },
      };
    case AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarFailed: {
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };   
    }
    case AuctionActionCalendarEnum.UpdateAuctionCalendarCorridorFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          corridors: action?.state?.currentFilters?.corridors,
        },
      };
    case AuctionActionCalendarEnum.UpateAuctionCalendarInterconnectorFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          interconnectors: action?.state?.currentFilters?.interconnectors,
        },
      };
    case AuctionActionCalendarEnum.UpateAuctionCalendarProductFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          products: action?.state?.currentFilters?.products,
        },
      };
    case AuctionActionCalendarEnum.UpdateAuctionCalendarExchangeFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          exchanges: action?.state?.currentFilters?.exchanges,
        },
      };
    case AuctionActionCalendarEnum.UpateAuctionCalendarIsShowFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          isShow: action?.state?.currentFilters?.isShow,
        },
      };
    default:
      return { ...state };
  }
};
